import { ReviewServices } from '@/services/review.services'

const state = {
  loading: false,
  dialogaddreview: false,
  dialog: false,
  overlay: false,
  reviews: [],
  totalreview: 0
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialogaddreview ({ commit }, diag) {
    commit('setdialogaddreview', diag)
  },
  addReview ({ dispatch, commit }, data) {
    commit('setloading', true)
    var memberid = data.memberid
    ReviewServices.addUserReview(data).then(value => {
      commit('setloading', false)
      commit('setdialogaddreview', false)
      dispatch('alert/success', value.msg, { root: true })
      ReviewServices.getUserReview({ memberid: memberid }).then(value => {
        commit('setloading', false)
        commit('setreviewdata', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  addReplayReview ({ dispatch, commit }, data) {
    commit('setloading', true)
    ReviewServices.addReplayUserReview(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getReviews ({ commit }, opt) {
    commit('setloading', true)
    ReviewServices.getUserReview(opt).then(value => {
      commit('setloading', false)
      commit('setreviewdata', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogaddreview (state, s) {
    state.dialogaddreview = s
  },
  setreviewdata (state, s) {
    state.reviews = []
    state.reviews = s.data.content
    state.totalreview = s.data.totalElements
    state.loading = false
    state.overlay = false
  }
}

export const ReviewStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
